import { render } from "./AddClientInline.vue?vue&type=template&id=c50229a4&scoped=true"
import script from "./AddClientInline.vue?vue&type=script&lang=js"
export * from "./AddClientInline.vue?vue&type=script&lang=js"

import "./AddClientInline.vue?vue&type=style&index=0&id=c50229a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c50229a4"]])

export default __exports__